import { getCountyByKey } from '@/constants/enums/counties';

export const AddressFormatter = ({ city, postal_code, county, region }) => {
  const countyName = county?.name;
  
  if (countyName) {
    return `${postal_code ? postal_code + ', ' : ''} ${city ? city + ', ' : ''} ${getCountyByKey(countyName)}`;
  }
  
  if (region) {
    return `${postal_code ? postal_code + ', ' : ''} ${city ? city + ', ' : ''} ${region}`;
  }
  
  return `${postal_code ? postal_code + ', ' : ''} ${city ? city + ', ' : ''}`;
};
